module.exports = __webpack_public_path__ + "img/UTGREA-9.1e63cdc1.jpg";